<template>
    <div class="my-0">
        <b-card>
            <div class="row">
                <div class="col-12 mt-0">
                    <!-- <p class="card-text bg-secondary pa-1"> -->
                    <p class="card-text">
                        <b>{{ hotel.hotel }}</b><br>
                        <span class="text-primary mb-2">{{ hotel.pobla }}</span>
                    </p>

                </div>
                <!-- <b-icon variant="success" icon="cart3"></b-icon> -->
                <!-- <div class="col-6">
                    <div class="form-group">
                        <label class="text-small" for="selectTransport">Salidas / Transporte</label>
                        <b-form-select v-model="salida"
                            :options="salidas"
                            class="mb-1"
                        ></b-form-select>
                    </div>
                </div> -->
            </div>
            <b-table striped hover sticky-header="460px" head-variant="light"
                :items="turnosFiltrados" :fields="turnos.fields"
                class="table-responsive-md bg-white mt-2" responsive="sm">

                <template slot="cell(sal)" slot-scope="{item: { sal }}">
                    <small>{{ sal }}</small>
                </template>

                <template #cell(action)="data">
                    <b-btn size="lg" variant="light" class="p-0" v-if="data.item.lib<=0">
                        <b-icon variant="danger" icon="x-square"></b-icon>
                    </b-btn>
                    <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                        <b-icon icon="cart4" class="mr-1"></b-icon>
                        <b-badge variant="primary" class="mr-1">{{data.item.lib3}}</b-badge>
                        <b-badge variant="warning" class="mr-1">{{data.item.lib2}}</b-badge>
                        <b-badge variant="dark">{{data.item.lib1}}</b-badge>
                    </b-btn>
                    <!-- <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                        <b-icon icon="cart3"></b-icon>
                        <b-badge variant="success">{{data.item.lib}}</b-badge>
                    </b-btn> -->
                </template>

            </b-table>
            <!-- <p><small>Periodos </small> <b> {{turnos.items.length}} </b></p> -->
        </b-card>
        <div class="row mx-1 pl-2 mt-0 bg- text-faded">
            <div class="col-4">Periodos <b>{{turnosFiltrados.length}}</b></div>
            <div class="col-8">
                <b-icon variant="success" icon="cart4"></b-icon> Reserva &nbsp;
                <b-icon variant="primary" icon="circle-fill"/><small>Doble</small>
                <b-icon variant="warning" icon="circle-fill"></b-icon><small>Doble Comp.</small>
                <b-icon variant="dark" icon="circle-fill"></b-icon><small>Individual</small>
                <!-- <b-icon variant="danger" icon="x-square" class="ml-4"></b-icon> Sin disponibilidad -->
                &nbsp;<b-icon variant="danger" icon="cart2" class="ml-4"></b-icon><small>Sin Disponibilidad</small>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'hotelPrecios',

    data() {
        return {
            //hotel: {},
            //salida: '',
        }
    },
    computed: {
        hotel() {
            return this.$store.state.hoteles.hotel;
        },
        turnos() {
            return this.$store.state.hoteles.turnos;
        },
        reserva() {
            return this.$store.state.reserva;
        },
        turnosFiltrados() {
            var H=this.turnos.items;
            /* if (this.salida!==null) {
                H = H.filter(item => item.sal.indexOf(this.salida) != -1);
            } */
            return H;
        },

        salidas() {
            /* // let result=this.$util.object_array(this.turnos.items);
            let result=this.turnos.items;

            var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
            result.forEach(value => {
                let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

                let names = A.map(e => e.value);
                console.log(names.includes(value.sal)); // returns true
                if (!names.includes(value.sal))
                    A.push({text:txt, value:value.sal, disabled:false});
            });
            //this.salida='';
            return A; */
            return [];
        },

    },
    methods: {

        selecciona(item) {
            this.$store.state.hoteles.hotel=this.hotel;
            item.item.hotel=this.hotel.hotel;
            this.$store.state.hoteles.turno=item.item;

            //reserva
            this.reserva.hot=item.item.hot;
            this.reserva.fhe=item.item.fhe; this.reserva.fhs=item.item.fhs; this.reserva.noc=item.item.noc;
            this.reserva.pre=item.item.pre;
            this.reserva.turno=item.item.id;
            this.reserva.reg='PC'; //itm.item.reg;


            // abrimos reserva sino ...
            if (this.$route.name!='reserva') this.$router.push('/reserva');
            this.close();
        },

        close() {
            this.$bvModal.hide('modal_hotelPrecios');
        }
    }
}
</script>
